import { useEffect, useState } from "react";
import axiosInstance from "./axiosInstance";

// The hotel's standard check-in / checkout clock, configured in onboarding. The backend
// stamps it onto every booking it saves, so the forms pre-fill with it to show staff the
// time the booking will actually end up with.
export function useStayTimes() {
    const [stayTimes, setStayTimes] = useState({
        checkin_time: "",
        checkout_time: "",
    });

    useEffect(() => {
        const hotelId = localStorage.getItem("hotelId");
        if (!hotelId) return;

        let cancelled = false;
        axiosInstance
            .get(`/api/v1/hotels/${hotelId}/stay-times`)
            .then((response) => {
                if (cancelled) return;
                setStayTimes({
                    checkin_time: response.data?.checkin_time || "",
                    checkout_time: response.data?.checkout_time || "",
                });
            })
            .catch((error) => {
                console.error("Error fetching hotel stay times:", error);
            });

        return () => {
            cancelled = true;
        };
    }, []);

    return stayTimes;
}

// Rewrites the time-of-day of a "YYYY-MM-DDTHH:mm" datetime-local value, keeping its date.
// An unset clock leaves the value untouched, matching the backend's no-override behaviour.
export function applyStayTime(value, clock) {
    if (!value || !clock) return value;

    const [date] = String(value).split("T");
    if (!date) return value;

    return `${date}T${clock}`;
}
